import { BehaviorSubject } from 'rxjs';

// Initialize with today's date

export const selectedDate$ = new BehaviorSubject<Date>(new Date);
